import React from 'react';
import { ApprovedPage as Renderer } from '../components/approved/ApprovedPage';
import { ContactForm } from '../components/approved/ContactForm';
import { TeamMembers } from '../components/approved/TeamMembers';
import * as deepReset from '../components/approved/content/deep-reset';
import * as commercial from '../components/approved/content/commercial';
import * as homeClean from '../components/approved/content/home-clean';
import * as airbnb from '../components/approved/content/airbnb';
import * as move from '../components/approved/content/move';
import * as about from '../components/approved/content/about';
import * as contact from '../components/approved/content/contact';
import '../styles/approved/deep-reset.css';
import '../styles/approved/commercial.css';
import '../styles/approved/home-clean.css';
import '../styles/approved/airbnb.css';
import '../styles/approved/move.css';
import '../styles/approved/about.css';
import '../styles/approved/contact.css';

const MOVE_REVEAL = {
  selector: '.situation-panel,.section-heading,.option-grid article,.readiness-heading,.readiness-board,.move-deadlines>div,.process-grid article,.faq>div,.closing>div',
  readyClass: 'move-reveal-ready',
  options: { threshold: 0, rootMargin: '0px 0px -45px 0px' },
};
const ABOUT_REVEAL = {
  selector: '.story-heading,.story-copy,.profile-card,.standard-heading,.standard-steps,.about-contact',
  readyClass: 'reveal-on-scroll',
  options: { threshold: 0.05 },
};

const PAGES = {
  'deep-reset': { content: deepReset },
  commercial: { content: commercial },
  'home-clean': { content: homeClean },
  airbnb: { content: airbnb },
  move: { content: move, reveal: MOVE_REVEAL },
  about: { content: about, reveal: ABOUT_REVEAL, slots: { 'gp-team-slot': <TeamMembers /> } },
  contact: { content: contact, slots: { 'gp-contact-form-slot': <ContactForm /> } },
};

export default function ApprovedSitePage({ page }) {
  const cfg = PAGES[page];
  return <Renderer key={page} slug={page} {...cfg} />;
}
